module.exports = __webpack_public_path__ + "img/lg.abab7fff.svg";